import { TemplateRef } from "@angular/core";
import { Message } from "primeng/api";

export enum AvanoMessageCategory {'info' ,'warning' ,'error' ,'success' , 'appinfo'}
export enum AvanoMessageType {
  'feedback',
  'notification',
  'custom'
}

export interface AvanoCustomMessage<T = unknown> {
  toasterTemplate?: TemplateRef<any>;
  detailsTemplate?: TemplateRef<any>;
  data: T;
}
export interface AvanoMessage extends Message {
  messageType: AvanoMessageType;
  messageDetails?: AvanoCustomMessage;
  data?: {
    detailsButton?: { label: string, icon: string, action: () => void };
  }
}
export interface AvanoNotification {
  category: AvanoMessageCategory;
  title: string;
  description: string;
  detailsButton?: { label: string, icon: string, action: () => void };
  lifeTime?: number;
}

export interface AvanoActionFeedback {
  category: AvanoMessageCategory;
  text: string,
  lifeTime?: number;
}